import Table from "@/common/components/Table";
import { companyFeeColumns } from "@/features/privateCompanies/constants/companyFeeColumns.constant";
import { useCompanyGroupedFee } from "@/features/privateCompanies/hooks/useCompanyGroupedFee";
import { CompanyFeeTransformer } from "@/features/privateCompanies/services/companyFeeTransnformer";

export const EventFeeTable = ({ eventId }: { eventId: string }) => {
  const { data: groupedFee, isFetching } = useCompanyGroupedFee(eventId);

  return (
    <div className="mb-4 last:mb-0">
      <Table
        className="rounded-none"
        columns={companyFeeColumns}
        rows={CompanyFeeTransformer.tableTransformer()(groupedFee) || []}
        rowEmptyValue="--"
        page={1}
        totalPages={1}
        loadingRows={3}
        isLoadingData={isFetching}
        emptyDataClassName="max-h-[217px]"
        emptyDataImageHeight={120}
      />
    </div>
  );
};